<template>
  <section class="basic">
    <div class="info overflow1 landnumber">{{ infoData.landnumber }}</div>
    <div class="info overflow1 annoid">{{ infoData.annoid }}</div>
    <div class="info overflow1 address">{{ infoData.address }}</div>
    <div class="info overflow1 province">
      {{ infoData.province ? infoData.province : "四川省" }}
    </div>
    <div class="info overflow1 landcity">{{ infoData.landcity }}</div>
    <div class="info overflow1 region">{{ infoData.region }}</div>
    <div class="info overflow1 torus">{{ infoData.torus }}</div>
    <div class="info overflow1 landarea1">
      {{
        infoData.landarea1 == "/"
          ? infoData.landarea1
          : infoData.landarea1 + "m²"
      }}
    </div>
    <div class="info overflow1 landnature">{{ infoData.landnature }}</div>
    <div class="info overflow1 useryears">{{ infoData.useryears }}</div>
    <!-- <div class="info overflow1 syzb">{{infoData}}</div> -->
    <div class="info overflow1 volumeratio">{{ infoData.volumeratio }}</div>
    <div class="info overflow1 buildarea">
      {{
        infoData.buildarea == "/"
          ? infoData.buildarea
          : infoData.buildarea + "m²"
      }}
    </div>
    <div class="info overflow1 businessarea">
      {{
        infoData.businessarea == "/"
          ? infoData.businessarea
          : infoData.businessarea + "m²"
      }}
    </div>
    <div class="info overflow1 greenrate">{{ infoData.greenrate }}</div>
    <div class="info overflow1 buildingheight">
      {{ infoData.buildingheight }}
    </div>
    <div class="info overflow1 sellremark">{{ infoData.sellremark }}</div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      infoData: "",
    };
  },

  components: {},

  mounted() {
    this.bus.$on("setLandInfo", (val) => {
      this.infoData = val;
    });
  },

  methods: {},
};
</script>
<style lang='scss' scoped>
.basic {
  width: 872px;
  height: 888px;
  background-image: url("./../../../assets/imgs/landInfo/basic.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .overflow1 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    word-break: break-all;
  }
  .info {
    color: #fff;
    font-size: 32px;
    position: absolute;
  }
  .landnumber {
    left: 220px;
    top: 78px;
  }
  .annoid {
    left: 220px;
    top: 125px;
  }
  .address {
    left: 220px;
    top: 172px;
  }
  .province {
    left: 220px;
    top: 257px;
  }
  .landcity {
    left: 624px;
    top: 257px;
  }
  .region {
    left: 220px;
    top: 307px;
  }
  .torus {
    left: 624px;
    top: 307px;
  }
  .landarea1 {
    left: 220px;
    top: 361px;
  }
  .landnature {
    left: 624px;
    top: 361px;
    width: 200px;
  }
  .useryears {
    left: 220px;
    top: 414px;
  }
  .volumeratio {
    left: 283px;
    top: 467px;
  }
  .buildarea {
    left: 283px;
    top: 520px;
  }
  .businessarea {
    left: 691px;
    top: 520px;
    max-width: 152px;
  }
  .greenrate {
    left: 283px;
    top: 572px;
  }
  .buildingheight {
    left: 283px;
    top: 626px;
    -webkit-line-clamp: 4;
    max-width: 528px;
  }
  .sellremark {
    left: 283px;
    top: 824px;
    max-width: 528px;
  }
}
</style>